module.exports = __webpack_public_path__ + "img/Electricity_orange_Button.93f99585.png";